var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImgAllDailyTargetLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55921_15121)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#6360F6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9002 6.17734H16.2002V4.77734H14.8002V6.17734H9.2002V4.77734H7.8002V6.17734H7.1002C6.3232 6.17734 5.7072 6.80734 5.7072 7.57734L5.7002 17.3773C5.7002 18.1473 6.3232 18.7773 7.1002 18.7773H16.9002C17.6702 18.7773 18.3002 18.1473 18.3002 17.3773V7.57734C18.3002 6.80734 17.6702 6.17734 16.9002 6.17734ZM16.9002 17.3773H7.1002V9.67734H16.9002V17.3773ZM8.5002 11.0773H12.0002V14.5773H8.5002V11.0773Z",
    fill: "#6360F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55921_15121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImgAllDailyTargetLearning);
export default __webpack_public_path__ + "static/media/iconImgAllDailyTargetLearning.082db3f4d5334ff5dbc09be9117509a7.svg";
export { ForwardRef as ReactComponent };